import React from "react";
import { useParams } from "react-router-dom";
import NoticeDetails from "./NoticeDetails";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";
import CpntDetailsNotAccess, { TypeAffichage } from "../../../components/CpntDetailsNotAccess";
import { useFetchNoticeSecureQuery } from "../../../redux/slice/api/FO/noticeApi";
import SpinnerEditeurPro from "../components/SpinnerEditeurPro";

const PageNoticeDetailsExterne: React.FC = () => {
  const { parame:parameUrl , parami:paramiUrl} = useParams();
  const parameValue = parameUrl ?? "";
  const paramiValue = paramiUrl ?? "";

  
  const { data: NoticeResult, isFetching: isFetchingNoticeResult } = useFetchNoticeSecureQuery({ ParamE: parameValue, ParamI: paramiValue }, {
    refetchOnMountOrArgChange: true,
    skip: parameValue === null || paramiValue === "",
  });

  
  return (
    <>
     <div className="container">
        {isFetchingNoticeResult && !NoticeResult ? (
          <SpinnerEditeurPro />
        ) : NoticeResult && NoticeResult?.Return_IdType_Message === Type_Return_Message.Erreur ? (
          <div>
            <CpntDetailsNotAccess text="Votre publication n'est pas encore visible sur electre.com" typeAffichage={TypeAffichage.Notice} />
          </div>
        ) : (
          <NoticeDetails NoticeResult={NoticeResult?.NoticeDetails} isFetchingNoticeResult={isFetchingNoticeResult} btnModifierAutoVisible={false} btnModifierMessageVisible={false} />
        )}
      </div>
     </>
  );
};
 
export default PageNoticeDetailsExterne;
 